import 'react-app-polyfill/stable'
import { initApp } from './app'

initApp(document.getElementById('root'))
